import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { environment } from "../environments/environment";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ApiServiceService {
  constructor(private http: HttpClient) {}

  //Category API EndPoint
  submitForm(formData: any) {
    console.log("request data : ", formData);
    const apiUrl = `${environment.baseUrl}/api/category/addAndUpdateCategory`;
    console.log("url : ", apiUrl);
    return this.http.post(apiUrl, formData);
  }

  getAllCategories(): Observable<any[]> {
    const apiUrl = `${environment.baseUrl}/api/category/getCategorylist`;
    console.log("apiUrl :", apiUrl);
    return this.http.get<any[]>(apiUrl);
  }
  deleteCategory(categoryId: number): Observable<any> {
    const apiUrl = `${environment.baseUrl}/api/category/deleteCategory`;
    return this.http.post<any>(apiUrl, { CategoryID: categoryId });
  }
  getCategoryByID(CategoryID: any) {
    const apiUrl = `${environment.baseUrl}/api/category/getCategoryByID`;
    console.log("edit id:", CategoryID);
    return this.http.post(apiUrl, { CategoryID: CategoryID });
  }

  updateCategory(formData: any) {
    console.log("request data : ", formData);
    const apiUrl = `${environment.baseUrl}/api/category/addAndUpdateCategory`;
    console.log("url : ", apiUrl);
    return this.http.post(apiUrl, formData);
  }
  //Subcategory API
  submitSubCategoryForm(formData: any) {
    console.log("request data for sub-category: ", formData);
    const apiUrl = `${environment.baseUrl}/api/subcategory/addAndUpdateSubCategory`;
    console.log("url for sub-category: ", apiUrl);
    return this.http.post(apiUrl, formData);
  }

  getCategoryNames(): Observable<string[]> {
    const url = `${environment.baseUrl}/api/category/getCategoryNames`;
    return this.http.get<string[]>(url);
  }

  getSubCategoryNames(): Observable<string[]> {
    const url = `${environment.baseUrl}/api/subcategory/getSubCategoryNames`;
    return this.http.get<string[]>(url);
  }

  getAllSubCategories(): Observable<any[]> {
    const apiUrl = `${environment.baseUrl}/api/subcategory/getSubCategorylist`;
    console.log("apiUrl :", apiUrl);
    return this.http.get<any[]>(apiUrl);
  }

  getSubCategoryByID(SubCategoryID: any) {
    const apiUrl = `${environment.baseUrl}/api/subcategory/getSubCategoryByID`;
    console.log("edit subCategoryId:", SubCategoryID);
    return this.http.post(apiUrl, { SubCategoryID: SubCategoryID });
  }

  updateSubCategoryForm(formData: any) {
    console.log("request data : ", formData);
    const apiUrl = `${environment.baseUrl}/api/subcategory/addAndUpdateSubCategory`;
    console.log("url : ", apiUrl);
    return this.http.post(apiUrl, formData);
  }

  deleteSubCategory(subCategoryId: number): Observable<any> {
    const apiUrl = `${environment.baseUrl}/api/subcategory/deleteSubCategory`;
    return this.http.post<any>(apiUrl, { SubCategoryID: subCategoryId });
  }
  //Food API
  submitFoodForm(formData: any): Observable<any> {
    console.log("submitFoodForm: ", formData);
    const apiUrl = `${environment.baseUrl}/api/food/addAndUpdateFood`;
    return this.http.post(apiUrl, formData);
  }

  getFoodNames(): Observable<string[]> {
    const url = `${environment.baseUrl}/api/food/getFoodNames`;
    return this.http.get<string[]>(url);
  }

  getAllFoodList(): Observable<any[]> {
    const apiUrl = `${environment.baseUrl}/api/food/getFoodList`;
    return this.http.get<any[]>(apiUrl);
  }

  getFoodById(foodID: any) {
    const apiUrl = `${environment.baseUrl}/api/food/getFoodByID`;
    console.log("edit food items:", foodID);
    return this.http.post(apiUrl, { foodID: foodID });
  }

  updateFoodItem(formData: any) {
    console.log("updateFoodItem: ", formData);
    const apiUrl = `${environment.baseUrl}/api/food/addAndUpdateFood`;
    return this.http.post(apiUrl, formData);
  }

  deleteFood(foodID: number): Observable<any> {
    const apiUrl = `${environment.baseUrl}/api/food/deleteFood`;
    return this.http.post<any>(apiUrl, { FoodID: foodID });
  }

  //Package API
  submitPackageForm(formData: any): Observable<any> {
    console.log("request data for package: ", formData);
    const apiUrl = `${environment.baseUrl}/api/package/AddPackage`;
    return this.http.post(apiUrl, formData);
  }

  getAllPackageList(): Observable<any[]> {
    const apiUrl = `${environment.baseUrl}/api/package/getPackagelist`;
    return this.http.get<any[]>(apiUrl);
  }

  getPackageById(PackageID: any): Observable<any> {
    const apiUrl = `${environment.baseUrl}/api/package/getPackageByID`;
    return this.http.post(apiUrl, { PackageID: PackageID });
  }

  updatePackage(formData: any): Observable<any> {
    console.log("request data for package: ", formData);
    const apiUrl = `${environment.baseUrl}/api/package/UpdatePackage`;
    return this.http.post(apiUrl, formData);
  }

  deletePackage(packageID: number): Observable<any> {
    const apiUrl = `${environment.baseUrl}/api/package/deletePackage`;
    return this.http.post<any>(apiUrl, { PackageID: packageID });
  }

  //Admin API
  submitAdminForm(formData: any): Observable<any> {
    console.log("adminusers: ", formData);
    const apiUrl = `${environment.baseUrl}/api/authentication/createAdminUser`;
    console.log("response: ", apiUrl);
    return this.http.post(apiUrl, formData);
  }
  getAdminUsers(): Observable<any[]> {
    const apiUrl = `${environment.baseUrl}/api/authentication/getAdminUserlist`;
    return this.http.get<any[]>(apiUrl);
  }

  getAdminUserById(userId: any): Observable<any> {
    const apiUrl = `${environment.baseUrl}/api/authentication/getAdminUserByID`;
    return this.http.post(apiUrl, { UserID: userId });
  }
  updateAdminUser(formData: any): Observable<any> {
    console.log("Request data for admin user: ", formData);
    const apiUrl = `${environment.baseUrl}/api/authentication/updateAdminUser`;
    console.log("URL for admin user: ", apiUrl);
    return this.http.post(apiUrl, formData);
  }
  getCountryList(): Observable<string[]> {
    const url = `${environment.baseUrl}/api/country/getCountryList`;
    console.log("country:", url);
    return this.http.get<string[]>(url);
  }

  getStateListBycountryID(Country: string): Observable<string[]> {
    const url = `${environment.baseUrl}/api/state/getStateListBycountryID`;
    return this.http.post<string[]>(url, { countryID: Country });
  }

  getCityListByStateID(State: string): Observable<string[]> {
    const url = `${environment.baseUrl}/api/city/getCityListByStateID`;
    return this.http.post<string[]>(url, { stateID: State });
  }

  //superadmin login
  adminLogin(formdata: any): Observable<any> {
    const apiUrl = `${environment.baseUrl}/api/authentication/adminlogin`;
    return this.http.post(apiUrl, formdata);
  }

  adminForgotPassword(formdata: any): Observable<any> {
    const apiUrl = `${environment.baseUrl}/api/authentication/adminforgotpassword`;
    return this.http.post(apiUrl, formdata);
  }
  adminResetPassword(formdata: any): Observable<any> {
    const apiUrl = `${environment.baseUrl}/api/authentication/adminresetpassword`;
    return this.http.post(apiUrl, formdata);
  }

  //Mobile Users
  getMobileUsers(): Observable<any[]> {
    const apiUrl = `${environment.baseUrl}/api/authentication/getMobileUserlist`;
    return this.http.get<any[]>(apiUrl);
  }
  getMobileUserById(userId: any): Observable<any> {
    const apiUrl = `${environment.baseUrl}/api/authentication/getMobileUserByID`;
    return this.http.post(apiUrl, { UserID: userId });
  }

  updateMobileUser(formData: any): Observable<any> {
    console.log("Request data for mobile user: ", formData);
    const apiUrl = `${environment.baseUrl}/api/authentication/updateMobileUser`;
    console.log("URL for mobile user: ", apiUrl);
    return this.http.post(apiUrl, formData);
  }

  ReportDetials(
    Username: string,
    EventDateFrom: Date | undefined,
    EventDateTo: Date | undefined
  ): Observable<any[]> {
    const queryParams: string[] = [];
    if (Username) {
      queryParams.push(`Username=${Username}`);
    }

    if (EventDateFrom) {
      queryParams.push(`EventDateFrom=${EventDateFrom}`);
    }

    if (EventDateTo) {
      queryParams.push(`EventDateTo=${EventDateTo}`);
    }

    let apiUrl = `${environment.baseUrl}/api/order/GetReportlist`;
    if (queryParams.length > 0) {
      apiUrl += `?${queryParams.join("&")}`;
    }

    console.log("api", apiUrl);

    return this.http.post<any[]>(apiUrl, {
      Username: Username,
      EventDateFrom: EventDateFrom,
      EventDateTo: EventDateTo,
    });
  }

  viewOrdersDetials(
    orderFrom: Date | undefined,
    orderTo: Date | undefined
  ): Observable<any[]> {
    const queryParams: string[] = [];

    if (orderFrom) {
      queryParams.push(`orderFrom=${orderFrom}`);
    }

    if (orderTo) {
      queryParams.push(`orderTo=${orderTo}`);
    }
    let apiUrl = `${environment.baseUrl}/api/order/viewOrdersDetials`;
    if (queryParams.length > 0) {
      apiUrl += `?${queryParams.join("&")}`;
    }
    console.log("api", apiUrl);
    return this.http.post<any[]>(apiUrl, {
      orderFrom: orderFrom,
      orderTo: orderTo,
    });
  }

  getOrderDetailsById(id: number): Observable<any> {
    console.log("order id  ", id);
    const apiUrl = `${environment.baseUrl}/api/order/getOrderDetailsByID`;
    return this.http.post(apiUrl, { OrderID: id });
  }
}
